import React from 'react';
import { Spin } from 'antd';
import * as Styled from './styled';

export const Loading = () => {
  return (
    <Styled.Container>
      <Spin />
    </Styled.Container>
  );
}
